export default [
  {
    path: '/store',
    name: 'Store',
    component: () => import('@/views/Store'),
    meta: {
      roles: ['distributor'],
    },
    children: [
      {
        path: 'storeTeam',
        name: 'StoreTeam',
        component: () => import('@/views/Store/StoreTeam'),
        meta: {
          roles: ['distributor'],
        },
      },
      {
        path: 'storeRedpack',
        name: 'StoreRedpack',
        component: () => import('@/views/Store/StoreRedpack'),
        meta: {
          roles: ['distributor'],
        },
      },
      {
        path: 'send',
        name: 'SendStoreRedpack',
        component: () => import('@/views/Store/StoreRedpack/send'),
        meta: {
          roles: ['distributor'],
        },
      },
      {
        path: 'storeOrder',
        name: 'StoreOrder',
        component: () => import('@/views/Store/StoreOrder'),
        meta: {
          roles: ['distributor'],
        },
        children: [
          {
            path: 'detail/:id',
            name: 'StoreOrderDetail',
            component: () => import('@/views/Store/StoreOrder/detail'),
            meta: {
              roles: ['distributor'],
            },
            children: [
              {
                path: 'Goods',
                name: 'StoreOrderDetailGoods',
                component: () =>
                  import('@/views/Store/StoreOrder/detail/goods'),
                meta: {
                  roles: ['distributor'],
                },
              },
            ],
          },
        ],
      },
      {
        path: 'storeAftSale',
        name: 'StoreAftSale',
        component: () => import('@/views/Store/StoreAftSale'),
        meta: {
          roles: ['distributor'],
        },
        children: [
          {
            path: 'detail',
            name: 'StoreAftSaleDetail',
            component: () => import('@/views/Store/StoreAftSale/detail'),
            meta: {
              roles: ['distributor'],
            },
            children: [
              {
                path: 'Goods',
                name: 'StoreAftSaleDetailGoods',
                component: () => import('@/views/Store/StoreAftSale/detail/goodsDetail'),
                meta: {
                  roles: ['distributor'],
                },
              },
            ],
          },
        ],
      },
      {
        path: 'storeCustomerRank',
        name: 'StoreCustomerRank',
        component: () => import('@/views/Store/StoreCustomerRank'),
        meta: {
          roles: ['distributor'],
        },
      },
      {
        path: 'storeSellData',
        name: 'StoreSellData',
        component: () => import('@/views/Store/StoreSellData'),
        meta: {
          roles: ['distributor'],
        },
      },
      {
        path: 'storeVisitor',
        name: 'StoreVisitor',
        component: () => import('@/views/Store/StoreVisitor'),
        meta: {
          roles: ['distributor'],
        },
        children: [
          {
            path: 'detail/:id',
            name: 'StoreVisitorDetail',
            component: () => import('@/views/Store/StoreVisitorDetail'),
            meta: {
              roles: ['distributor'],
            },
          },
        ],
      },
      {
        path: 'storePlaceData',
        name: 'StorePlaceData',
        component: () => import('@/views/Store/StorePlaceData'),
        meta: {
          roles: ['distributor'],
        },
        children: [
          {
            path: 'detail/:id',
            name: 'StorePlaceDataDetail',
            component: () => import('@/views/Store/StorePlaceData/detail'),
            meta: {
              roles: ['distributor'],
            },
          },
        ],
      },
      {
        path: 'storeCustomer',
        name: 'StoreCustomer',
        component: () => import('@/views/Store/StoreCustomer'),
        meta: {
          roles: ['distributor'],
        },
      },
    ],
  },
]